import PropTypes from 'prop-types'
import { baseSlicePropTypes } from '../slice.types'

/**
 * @typedef {Object} WarehouseAddress
 * @property {string} id
 * @property {string} name
 * @property {string} phone
 * @property {string} address_line1
 * @property {string} company_name
 * @property {string} city_locality
 * @property {string} state_province
 * @property {string} postal_code
 * @property {string} country_code
 * @property {string} address_residential_indicator
 * @property {string} email
 * @property {number} warehouse_id
 * @property {boolean} is_primary
 */

/**
 * @typedef {Object} WarehouseAddressesSlice
 * @extends {import('../slice.types').BaseSlice}
 * @property {Object.<string, WarehouseAddress>} data
 */

export const WAREHOUSE_ADDRESSES_ACTIONS = {
  SET_WAREHOUSE_ADDRESSES: 'SET_WAREHOUSE_ADDRESSES',
  SET_WAREHOUSE_ADDRESS: 'SET_WAREHOUSE_ADDRESS',
  SET_STATUS: 'SET_WAREHOUSE_ADDRESSES_STATUS',
  SET_ERRORS: 'SET_WAREHOUSE_ADDRESSES_ERRORS',
  CLEAR_ERRORS: 'CLEAR_WAREHOUSE_ADDRESSES_ERRORS'
}

export const initialWarehouseAddressesState = {
  status: 'idle',
  errors: [],
  data: {}
}

export const warehouseAddressesPropTypes = {
  ...baseSlicePropTypes,
  data: PropTypes.objectOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      phone: PropTypes.string,
      address_line1: PropTypes.string,
      company_name: PropTypes.string,
      city_locality: PropTypes.string,
      state_province: PropTypes.string,
      postal_code: PropTypes.string,
      country_code: PropTypes.string,
      address_residential_indicator: PropTypes.string,
      email: PropTypes.string,
      warehouse_id: PropTypes.number,
      is_primary: PropTypes.bool
    })
  )
}
